export { request } from './Api';

/*
 * Generate a globally unique identifier
 */
export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4(); // eslint-disable-line
}

export function mapStateToProps(state) {
  return state;
}

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export const availability = [
  { value: 'Flexible', label: 'Flexible' },
  { value: 'Semi-Flexible', label: 'Semi-Flexible' },
  { value: 'Fixed', label: 'Fixed' },
];

export const sex = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
];

export const fixedStatuses = [
  { value: 'Neutered', label: 'Neutered (fixed dog)' },
  { value: 'Spayed', label: 'Spayed (fixed bitch)' },
  { value: 'Entire', label: 'Entire (not fixed)' },
];

export const livingSituations = [
  { value: 'Any', label: 'Any' },
  { value: 'Apartment – no yard', label: 'Apartment – no yard' },
  { value: 'Apartment – yard', label: 'Apartment – yard' },
  { value: 'House – no yard', label: 'House – no yard' },
  { value: 'House - yard', label: 'House - yard' },
  // { value: 'House – yard and kennel', label: 'House – yard and kennel' },
  { value: 'Lifestyle block', label: 'Lifestyle block' },
  { value: 'Farm', label: 'Farm' },
  { value: 'Not applicable - no home-hangs', label: 'Not applicable - no home-hangs' },
];

export const regularity = [
  // { value: 'Any', label: 'Any' },
  { value: 'Adhoc / Non-regular', label: 'Adhoc / Non-regular' },
  { value: 'Daily', label: 'Daily' },
  { value: 'Weekly', label: 'Weekly' },
  { value: 'Fortnightly', label: 'Fortnightly' },
  { value: 'Monthly', label: 'Monthly' },
  { value: 'One off', label: 'One off' },
  { value: 'Open for discussion', label: 'Open for discussion' },
  { value: 'Not Applicable', label: 'Not Applicable' },
];



// WEBPACK FOOTER //
// ./src/utils/index.js